module.exports = __webpack_public_path__ + "img/sa.135d0c86.svg";